import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from '@mui/material';

import { TabPanel } from '../../../../../components/custom-essentials';
import { getColumnsNotes, getColumnsFlags, getColumnsAppointments } from '../table/getColumnsRelevantInfo';
import { Table } from '../../../../../components/table';
import { formatDateFull } from '../../../../../components/functions';

const defaultSorted=[{ dataField: 'start', order: 'asc' }];
const sizePerPageList = [10];
const sizePerPageInitial = 10;

function RITabContent(props){
    const { relInfo } = props;

    const [activeTabKey, setActiveTabKey] = useState(0)

    const columns = useMemo(() => {
        return {
            notes: getColumnsNotes(),
            appointments: getColumnsAppointments(),
            flags: getColumnsFlags(),
        };
    }, []);

    const { combinedNotes, appointments, flags, upcomingExams, student } = relInfo || {};
    
    // Ensure arrays are valid before passing to Table components
    const safeCombinedNotes = Array.isArray(combinedNotes) ? combinedNotes : [];
    const safeAppointments = Array.isArray(appointments) ? appointments : [];
    const safeFlags = Array.isArray(flags) ? flags : [];
    
    return (
        <>
            <Tabs
                id="relevantInfo"
                value={activeTabKey}
                onChange={(e, newValue) => setActiveTabKey(newValue)}
            >
                <Tab value={`Notes (${safeCombinedNotes.length})`}/>
            </Tabs>
            <TabPanel activeKey={activeTabKey} index={0}>
                <Table
                    tableName="assignedAppointments-relevantInfo"
                    sizePerPageList={sizePerPageList}
                    sizePerPageInitial={sizePerPageInitial}
                    data={safeCombinedNotes}
                    columns={columns.notes}
                    defaultSorted={defaultSorted}
                    emptyMessage="No notes were found"
                />
            </TabPanel>
            <TabPanel activeKey={activeTabKey} index={1}>
                <Table
                    sizePerPageList={sizePerPageList}
                    sizePerPageInitial={sizePerPageInitial}
                    data={safeAppointments}
                    columns={columns.appointments}
                    defaultSorted={defaultSorted}
                    emptyMessage="No appointments were found"
                />
            </TabPanel>
            <TabPanel activeKey={activeTabKey} index={2}>
                <Table
                    sizePerPageList={sizePerPageList}
                    sizePerPageInitial={sizePerPageInitial}
                    data={safeFlags}
                    columns={columns.flags}
                    defaultSorted={defaultSorted}
                    emptyMessage="No flags were found"
                />
            </TabPanel>
            <TabPanel activeKey={activeTabKey} index={3}>
                <h4>Upcoming Exams Info</h4>
                {upcomingExams ? (
                    <>
                        <div><b>Has Exams? </b> {upcomingExams.has_exams ? (parseInt(upcomingExams.has_exams) === 1 ? 'Yes' : 'No') : 'Not specified'}</div>
                        <div>
                            <b>Notes: </b>
                            <span className={upcomingExams.notes ? '' : 'text-mpOrange'}>
                                {upcomingExams.notes || 'None'}
                            </span>
                        </div>
                        {upcomingExams.date_updated && (
                            <div><b>Last Updated: </b> {formatDateFull(upcomingExams.date_updated)} {upcomingExams.updatedByName ? `by ${upcomingExams.updatedByName}` : ''}</div>
                        )}
                    </>
                ) : (
                    <div className="text-mpOrange">No upcoming exams information available</div>
                )}
            </TabPanel>
            <TabPanel activeKey={activeTabKey} index={4}>
                <h4>Student Info</h4>
                {student ? (
                    <>
                        <div><b>Name: </b> {student.first_name || ''} {student.last_name || ''}</div>
                        {student.primaryCenterName && <div><b>Primary Center: </b> {student.primaryCenterName}</div>}
                        {student.mp_weight !== undefined && <div><b>Seating Weight: </b> {student.mp_weight}</div>}
                        {student.grade !== undefined && <div><b>Grade: </b> {student.grade}</div>}
                        <div><b>School: </b>
                            <span className={student.school ? '' : 'text-mpOrange'}>{student.school || 'Not Listed'}</span>
                        </div>
                        {student.mp_teacher !== undefined && (
                            <div><b>Teacher: </b>
                                <span className={student.mp_teacher ? '' : 'text-mpOrange'}>{student.mp_teacher || 'Not Listed'}</span>
                            </div>
                        )}
                        {student.mp_this_month_start && <div><b>This Month Start: </b> {formatDateFull(student.mp_this_month_start)}</div>}
                        {student.mp_next_month_start && <div><b>Next Month Start: </b> {formatDateFull(student.mp_next_month_start)}</div>}
                    </>
                ) : (
                    <div className="text-mpOrange">No student information available</div>
                )}
            </TabPanel>
        </>
    );
}

export default connect(null, {

})(RITabContent);